import moment from 'moment'
import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, Outlet, useLocation, useNavigate} from 'react-router-dom'

import {
  GetReportId,
  GetSchedulerReportId,
  GetSingleMessageData,
} from './reportSlices/reportAnalytics'
import {KTSVG} from '../../../../_metronic/helpers'
import {useGetCampaignReportScheduleDetailsQuery} from '../../../../services/cellcast'
import PageLoading from '../../../routing/PageLoading'

const ReportPageSchedulerHeader = () => {
  const navigate = useNavigate()
  const ReportId = useSelector(GetSchedulerReportId)

  const {data, isFetching} = useGetCampaignReportScheduleDetailsQuery({campId: ReportId?.id})

  const messageData = data?.data

  if (isFetching) {
    return <PageLoading />
  }

  return (
    <>
      <div className='card eofy_sale'>
        <div className='position-absolute m-3 cursor-pointer'>
          <KTSVG
            onClick={() => navigate('/report-analytics/bulk-messages')}
            path='/media/icons/duotune/arrows/arr022.svg'
            className='svg-icon-2x'
          />
        </div>
        <div className='card-body pt-9 pb-0 eofy_header'>
          <div className='d-flex flex-wrap flex-sm-nowrap m-3'>
            <div className='me-7 mb-4'>
              <div className='symbol symbol-sms symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                <span>{messageData?.camp_type?.toUpperCase()}</span>
              </div>
            </div>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <span className='text-gray-800 fs-1 fw-bolder me-1'>{messageData?.name}</span>
                    <span className={` m-3 badge badge-light-danger fw-bold`}>{'In Progress'}</span>
                  </div>
                  <div className='d-flex flex-wrap fw-bold fs-6 mb-1 pe-2'>
                    <span
                      className='d-flex align-items-center text-hover-primary me-5 mb-2'
                      style={{color: '#767687'}}
                    >
                      <span className='me-1' style={{ color: '#191C30' }}>
                        Scheduled At
                      </span>{' '}
                      {`${moment(messageData?.scheduleAt).format('l')} at ${moment(
                        messageData?.scheduleAt
                      ).format('LT')}`}
                    </span>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-wrap flex-stack account-stack'>
                <div className='d-flex flex-column flex-grow-1 pe-8'>
                  <div className='d-flex flex-wrap'>
                    <div className='border border-gray-300 border-solid rounded min-w-125px py-2 px-4 me-4 mb-3'>
                      <div className='d-flex align-items-center'>
                        <div className='fs-3 fw-bolder'>${+messageData?.totalCost?.toFixed(4)}</div>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Send cost</div>
                    </div>
                    <div className='border border-gray-300 border-solid rounded min-w-125px py-2 px-4 me-4 mb-3'>
                      <div className='d-flex align-items-center'>
                        <div className='fs-3 fw-bolder'>
                          {`${moment(messageData?.scheduleAt).format('l')} at ${moment(
                            messageData?.scheduleAt
                          ).format('LT')}`}
                        </div>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Date sent</div>
                    </div>
                    <div className='border border-gray-300 border-solid rounded min-w-125px py-2 px-4 me-4 mb-3'>
                      <div className='d-flex align-items-center'>
                        <div className='fs-3 fw-bolder'>{messageData?.sender}</div>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Sender ID</div>
                    </div>
                    <div className='border border-gray-300 border-solid rounded min-w-125px py-2 px-4 me-4 mb-3'>
                      <div className='d-flex align-items-center'>
                        <div className='fs-3 fw-bolder'>
                          {messageData?.to?.selectedType == 'segmentOrTags'
                            ? 'List, Segments & Tags'
                            : messageData?.to?.selectedType}{' '}
                          ({messageData?.recipients})
                        </div>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>
                        To
                        {messageData?.to?.selectedType === 'segmentOrTags' &&
                          messageData?.targetNames &&
                          Array.isArray(messageData?.targetNames) &&
                          ' : ' + messageData?.targetNames.join(',')}
                      </div>
                    </div>

                    <div className='border border-gray-300 border-solid rounded min-w-125px py-2 px-4 me-4 mb-3'>
                      <div className='d-flex align-items-center'>
                        <div className='fs-3 fw-bolder'>
                          {+messageData?.deductibleCredits?.toFixed(4)}
                        </div>
                      </div>
                      <div className='fw-bold fs-6 text-gray-400'>Credit Used</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex overflow-auto h-55px'>
            <ul
              className='nav nav-stretch nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap eofy_tabs'
              id='myTab'
              role='tablist'
            ></ul>
          </div>
        </div>
        <div className='tab-content'>
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default ReportPageSchedulerHeader
